import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartnerInfoDto } from 'src/app/api/models/OK/EGIS/Service/Ekstern/Models/DTO/partner-info-dto';

@Component({
  selector: 'app-partner-dialog',
  templateUrl: './partner-dialog.component.html',
  styleUrls: ['./partner-dialog.component.scss'],
})
export class PartnerDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: PartnerInfoDto) {}

  ngOnInit(): void {}
}
